import { z } from 'zod';

const HEX_COLOR = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

export const isHexColor = (value: string): boolean => HEX_COLOR.test(value);

export const hexColorSchema = z.string().refine(isHexColor, 'Must be a hex color like #153298');

// Lives here rather than in @glomopay/theme so @glomopay/tenant can share it:
// tenant validates the wire payload and theme validates the design-system config,
// and tenant depends only on this package and zod.
export const brandGradientSchema = z.object({
  from: hexColorSchema,
  to: hexColorSchema,
  angle: z.coerce.number().min(0).max(360).default(45),
});

export type TBrandGradient = z.infer<typeof brandGradientSchema>;
